<dx-drop-down-button
  icon="overflow"
  class="overflow-menu"
  [showArrowIcon]="false"
  stylingMode="text"
  [dropDownOptions]="{ width: 'auto' }"
  [items]="items"
  [visible]="visible"
></dx-drop-down-button>
